/**
 * @module app.shared
 */

abstract class TitleEvent { }
export class TitleChangeEvent extends TitleEvent {  // Replaces title:changed
    constructor(public title?: string[]) {
        super();
        return Object.assign<TitleChangeEvent, TitleChangeEvent>(this, { title: title });
    }
}

export class MenuRefreshEvent { }
export class StoreFocusEvent { }
export class EnableReturnFocusEvent { }
export class ReturnFocusEvent { }
export class SetFocusEvent {
    constructor(public focalElement: HTMLElement) {
        return Object.assign<SetFocusEvent, SetFocusEvent>(this, { focalElement: focalElement });
    }
}
export class AppRefocusEvent { }
export class ApiPendingIncreaseEvent { }
export class ApiPendingDecreaseEvent { }
export class DynamicGridReloadEvent { }
export class DynamicGridEditLayoutPreviewEvent {
    constructor(public gridKeys: string[]) {
        return Object.assign<DynamicGridEditLayoutPreviewEvent, DynamicGridEditLayoutPreviewEvent>(this, { gridKeys: gridKeys });
    }
}
